<template>
  <div>
    <a-card class="margin-bottom" title="Master Interval Workflow">
      <a-input-search
        @pressEnter="handleSearch()"
        enter-button
        v-model="filter.search"
        placeholder="Quick search & press enter"
      />
      <a-form-model layout="vertical" class="margin-top">
        <a-row :gutter="14" type="flex" justify="space-between">
          <a-col :span="8">
            <a-form-model-item label="Transaction Type">
              <a-select
                showSearch
                allowClear
                placeholder="Please Select Transaction Type"
                v-model="filter.transaction_type"
              >
                <a-select-option
                  v-for="(item, index) in fungsi"
                  :key="index"
                  :value="item.fungsi"
                >
                  {{ item.fungsi }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="Type">
              <a-select
                allowClear
                showSearch
                placeholder="Please Select Type"
                v-model="filter.type"
              >
                <a-select-option
                  v-for="(item, index) in jenis"
                  :key="index"
                  :value="item.jenis"
                >
                  {{ item.jenis }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="Unit Interval">
              <a-select
                allowClear
                showSearch
                placeholder="Please Select Interval"
                v-model="filter.unit_interval"
              >
                <a-select-option
                  v-for="(item, index) in unitInterval"
                  :key="index"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-table
      :columns="columns"
      :dataSource="processedSource"
      id="id_wf_dtl"
      size="small"
      :pagination="pagination"
      bordered
    >
      <template slot="no" slot-scope="value, item, index">
        {{ (pagination.page - 1) * 10 + (index + 1) }}
      </template>
      <template slot="actor" slot-scope="item">
        <span>{{ `${item.actor} (step: ${item.step_no})` }}</span>
      </template>
      <template slot="interval" slot-scope="item">
        <span>{{
          `${item.interval ? item.interval : ""} ${item.unit ? item.unit : ""}`
        }}</span>
      </template>
      <template slot="action" slot-scope="item">
        <a-button @click="handleEdit(item)" icon="edit">Interval</a-button>
      </template>
    </a-table>
    <a-modal
      title="Edit Interval Workflow"
      :width="500"
      centered
      @cancel="handleCancel"
      @ok="submitEdit"
      :maskClosable="false"
      ok-text="Submit"
      v-model="selected.visible"
      :confirmLoading="loading"
    >
      <ul class="m-list-wrapper">
        <li>
          <a-row :gutter="12">
            <a-col span="14">
              <span class="m-list-title"> Transaction </span>
              <span class="m-list-desc">{{ selected.item.transaksi }}</span>
            </a-col>
            <a-col span="10">
              <span class="m-list-title"> Type </span>
              <span class="m-list-desc">{{ selected.item.type }}</span>
            </a-col>
          </a-row>
        </li>
        <li>
          <a-row :gutter="12">
            <a-col span="4">
              <span class="m-list-title"> Step </span>
              <span class="m-list-desc">{{ selected.item.step_no }}</span>
            </a-col>
            <a-col span="10">
              <span class="m-list-title"> Actor </span>
              <span class="m-list-desc">{{ selected.item.actor }}</span>
            </a-col>
            <a-col span="10">
              <span class="m-list-title"> Type Approval </span>
              <span class="m-list-desc">{{ selected.item.type_approval }}</span>
            </a-col>
          </a-row>
        </li>
      </ul>
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-form-model-item label="Interval" prop="interval">
          <a-input v-model="form.interval"></a-input>
        </a-form-model-item>
        <a-form-model-item label="Unit Interval" prop="unit">
          <a-select
            showSearch
            placeholder="Please Select Unit"
            v-model="form.unit"
          >
            <a-select-option
              v-for="(item, index) in unitInterval"
              :key="index"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "interval-page",
  data() {
    const columns = [
      {
        title: "No",
        scopedSlots: { customRender: "no" },
        align: "center",
        width: 30,
      },
      {
        title: "Transaction",
        dataIndex: "transaksi",
        width: 170,
      },
      {
        title: "Type",
        dataIndex: "type",
        width: 120,
      },
      {
        title: "Actor",
        width: 120,
        scopedSlots: { customRender: "actor" },
      },
      {
        title: "Type Approval",
        dataIndex: "type_approval",
        scopedSlots: { customRender: "type_approval" },
        width: 100,
      },
      {
        title: "Interval",
        width: 100,
        scopedSlots: { customRender: "interval" },
      },
      {
        title: "Action",
        width: 80,
        align: "center",
        scopedSlots: { customRender: "action" },
      },
    ];
    const unitInterval = ["SECOND", "MINUTE", "HOUR", "DAY", "MONTH", "YEAR"];
    return {
      form: {
        interval: 0,
        unit: "",
      },
      rules: {
        interval: [{ required: true, trigger: "blur" }],
        unit: [{ required: true, trigger: "change" }],
      },
      unitInterval,
      columns,
      fungsi: [],
      jenis: [],
      source: [],
      processedSource: [],
      pagination: {
        page: 1,
        onChange: (page) => {
          this.pagination.page = page;
        },
        pageSize: 10,
        size: "small",
      },
      selected: {
        visible: false,
        item: {},
      },
      loading: false,
      filter: {
        search: "",
        transaction_type: "",
        type: "",
        unit_interval: "",
      },
    };
  },
  mounted() {
    this.fetch();
  },
  watch: {
    "filter.search"() {
      if (this.filter.search == "") {
        this.handleSearch();
      }
    },
    "filter.transaction_type"() {
      this.handleSearch();
    },
    "filter.type"() {
      this.handleSearch();
    },
    "filter.unit_interval"() {
      this.handleSearch();
    },
  },
  computed: {
    ...mapGetters(["getAuth"]),
  },
  methods: {
    async fetch() {
      await this.$store
        .dispatch("getIntervalWorkflow", { auth: this.getAuth })
        .then((res) => {
          this.source = res.data;
          this.processedSource = res.data;
          this.fungsi = res.data_fungsi;
          this.jenis = res.data_jenis;
        });
    },
    handleEdit(item) {
      this.selected = {
        visible: true,
        item: item,
      };
      this.form = {
        interval: item.interval,
        unit: item.unit,
      };
    },
    handleCancel() {
      this.selected = {
        visible: false,
        item: {},
      };
    },
    handleSearch() {
      let output = this.source;
      if (this.filter.search !== "") {
        output = output.filter(
          (item) =>
            (item.transaksi &&
              item.transaksi
                .toLowerCase()
                .indexOf(this.filter.search.toLowerCase()) >= 0) ||
            (item.step_no && item.step_no.indexOf(this.filter.search) >= 0) ||
            (item.interval && item.interval.indexOf(this.filter.search) >= 0) ||
            (item.type &&
              item.type
                .toLowerCase()
                .indexOf(this.filter.search.toLowerCase()) >= 0) ||
            (item.type_approval &&
              item.type_approval
                .toLowerCase()
                .indexOf(this.filter.search.toLowerCase()) >= 0) ||
            (item.actor &&
              item.actor
                .toLowerCase()
                .indexOf(this.filter.search.toLowerCase()) >= 0)
        );
      }
      if (
        this.filter.transaction_type !== "" &&
        this.filter.transaction_type != undefined
      ) {
        output = output.filter(
          (item) =>
            item.fungsi.toLowerCase() ==
            this.filter.transaction_type.toLowerCase()
        );
      }
      if (
        this.filter.unit_interval != "" &&
        this.filter.unit_interval != undefined
      ) {
        output = output.filter(
          (item) => item.unit == this.filter.unit_interval
        );
      }

      if (this.filter.type != "" && this.filter.type != undefined) {
        output = output.filter((item) => item.type == this.filter.type);
      }

      this.processedSource = output;
    },
    submitEdit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading = true;
        this.$store
          .dispatch("putIntervalWorkflow", {
            auth: this.getAuth,
            data: {
              id_wf_dtl: this.selected.item.id_wf_dtl,
              interval: this.form.interval,
              unit: this.form.unit,
            },
          })
          .then((res) => {
            this.fetch().then((res) => {
              this.handleSearch();
              this.displayMessage("success");
              this.handleCancel();
              this.loading = false;
            });
          })
          .catch((err) => {
            this.loading = false;
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
          });
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
